import React, { useState, useEffect, useRef } from "react";
import { heroContent } from "../../constants/heroContent";
import "./hero.css";

const Hero = () => {
  const [cursorLoc, setCursorLoc] = useState({ x: 0, y: 0 });
  const [displayText, setDisplayText] = useState({ name: "", text: "" });
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const logoImgRef = useRef([]);
  const windowHeightRef = useRef(window.innerHeight);

  // Track cursor position only when within the hero viewport boundary
  useEffect(() => {
    const handleMouseMove = (event) => {
      if (window.scrollY < windowHeightRef.current * 0.8) {
        setCursorLoc({ x: event.clientX, y: event.clientY });
      }
    };

    window.addEventListener("mousemove", handleMouseMove, { passive: true });
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  // Handle image offsets relative to cursor coordinates
  useEffect(() => {
    logoImgRef.current.forEach((logoEl) => {
      if (!logoEl) return;

      const rect = logoEl.getBoundingClientRect();

      // If cursor is above the image
      if (rect.y > cursorLoc.y) {
        if (rect.left > cursorLoc.x) {
          // Cursor is upper left
          logoEl.style.transform = "translateY(-5%) translateX(-5%)";
        } else if (rect.right < cursorLoc.x) {
          // Cursor is upper right
          logoEl.style.transform = "translateY(-5%) translateX(5%)";
        } else {
          // Cursor is directly above
          logoEl.style.transform = "translateY(-5%)";
        }
      } else {
        // Cursor is below the image
        logoEl.style.transform = "translateY(5%) translateX(-5%)";
      }
    });
  }, [cursorLoc]);

  const handleMouseOverImage = (idx, name, text) => {
    setHoveredIndex(idx);
    setDisplayText({ name, text });
  };

  const handleMouseOutImage = () => {
    setHoveredIndex(null);
    setDisplayText({ name: "", text: "" });
  };

  return (
    <div className="hero__container">
      <div className="hero__headline__container">
        <p className="hero__headline">
          Talent acquisition partners for venture-backed, private equity-backed,
          and high-growth companies.
        </p>
      </div>

      <div className="hero__logo__container">
        {heroContent.slice(0, 14).map((logo, idx) => (
          <img
            key={`${logo.name}-${idx}`}
            ref={(el) => (logoImgRef.current[idx] = el)}
            id={`logo__${idx}`}
            src={logo.imgUrl}
            alt={`${logo.name} logo`}
            /* Dynamic declarative blurring handled cleanly through class toggles */
            className={`hero__logo--image ${
              hoveredIndex !== null && hoveredIndex !== idx ? "is-blurred" : ""
            }`}
            onMouseEnter={() =>
              handleMouseOverImage(idx, logo.name, logo.liner)
            }
            onMouseLeave={handleMouseOutImage}
          />
        ))}
      </div>
    </div>
  );
};

export default Hero;
